import type LineString from "ol/geom/LineString";
import { getLength } from "ol/sphere";

export function formatLength(line: LineString, locale = "en-US"): string {
  const length = getLength(line);
  if (length > 1000) {
    return `${(length / 1000).toLocaleString(locale, {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    })} km`;
  }
  return `${Math.round(length).toLocaleString(locale)} m`;
}

export function formatArea(area: number, locale = "en-US"): string {
  if (area > 1_000_000) {
    return `${(area / 1_000_000).toLocaleString(locale, {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    })} km2`;
  }
  return `${Math.round(area).toLocaleString(locale)} m2`;
}
